import { render, staticRenderFns } from "./Pasta.vue?vue&type=template&id=cb865c66&scoped=true&"
import script from "./Pasta.vue?vue&type=script&lang=js&"
export * from "./Pasta.vue?vue&type=script&lang=js&"
import style0 from "./Pasta.vue?vue&type=style&index=0&id=cb865c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb865c66",
  null
  
)

export default component.exports